<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocTodoPictoTexte'
});
</script>
<template>
  <ka-container
    code="bloc-todo-picto-texte"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-icon
      code="icon"
      value="i-fa-solid:check-circle" />
    <ka-text
      code="text"
      :value="componentInstance.$text.value" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocTodoPictoTexteComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c37')
const component = blocTodoPictoTexteComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  text?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  text: 'Donner un titre à la formation',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:text'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: { text: true }
})
</script>
